import React from 'react';
import { useTranslation } from 'react-i18next';
import './DonationComponent.css';

function DonationComponent({ format = 'vertical' }) {
  const { t } = useTranslation();

  // Determina il layout in base al formato (verticale o orizzontale)
  const isVertical = format === 'vertical';

  return (
    <div className={`donation-container ${isVertical ? 'donation-vertical' : 'donation-horizontal'}`} >
      <h3 className="donation-title main-h-color">{t('donation.title')}</h3>

      <p className="donation-description">
        {t('donation.description')}
      </p>

      <div className="donation-button-container">
          <form action="https://www.paypal.com/donate" method="post" target="_blank">

              <input type="hidden" name="no_recurring" value="0"/>
              <input type="hidden" name="business" value="asksenecatoday@gmail.com"/>
              <input type="hidden" name="currency_code" value="EUR"/>
              <input
                  type="image"
                  src="https://www.paypalobjects.com/it_IT/IT/i/btn/btn_donateCC_LG.gif"
                  name="submit"
                  title={t('donation.buttonAlt')}
                  alt={t('donation.buttonAlt')}
                  className="paypal-button"
              />
          </form>
      </div>

        <p className="donation-footer">
        {t('donation.footer')}
      </p>
    </div>
  );
}

export default DonationComponent;
